import { ArrowBack } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useWall } from '../App';
import { AddressField } from '../components';

import { Label } from "../style";
import { sizes } from "../variables";
import { EmptyContainer } from "./style";

const EmptyWall = () => {
  const { mobile } = useWall();
  const navigate = useNavigate();

  return (
    <EmptyContainer>
      <img src="/assets/logo.svg" width="10%" alt="Wallverse's logomark" />
      <Label fontFamily="Julius Sans One" fontSize={sizes.xl4} textAlign="center">
        Create your own <span className="highlight">wallverse experience</span>
      </Label>
      <AddressField half={mobile} />
      <Button color="primary" size="large" onClick={() => navigate('/about')} aria-label="Navigate to the about page">
        <ArrowBack sx={{ marginRight: sizes.xs2 }} />
        Learn more about wallverse
      </Button>
    </EmptyContainer>
  );
};

export default EmptyWall;
